interface MailTemplate {
  id: number;
  name: string;
  subject: string;
  body: string; // HTML content of the template
  created_at: string;
}

interface ViewMailTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  mailTemplate: MailTemplate | null;
}

const ViewMailTemplateModal = ({ isOpen, onClose, mailTemplate }: ViewMailTemplateModalProps) => {
  if (!isOpen || !mailTemplate) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">View Mail Template</h2>
        <div className="space-y-4">
          <div>
            <p className="gothic-text-silver"><strong className="gothic-text-gold">ID:</strong> {mailTemplate.id}</p>
            <p className="gothic-text-silver"><strong className="gothic-text-gold">Name:</strong> {mailTemplate.name}</p>
            <p className="gothic-text-silver"><strong className="gothic-text-gold">Subject:</strong> {mailTemplate.subject}</p>
            <p className="gothic-text-silver"><strong className="gothic-text-gold">Created At:</strong> {new Date(mailTemplate.created_at).toLocaleString()}</p>
            <p className="gothic-text-silver"><strong className="gothic-text-gold">Body (HTML):</strong></p>
            <div
              className="gothic-panel p-4 border border-gray-700 bg-gray-900"
              dangerouslySetInnerHTML={{ __html: mailTemplate.body }}
            ></div>
          </div>
          <div className="flex justify-end">
            <button onClick={onClose} className="gothic-button">Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMailTemplateModal;
